import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../../Context';

// eslint-disable-next-line max-len
import AssistantGenerateRoutesDialogByTemplateContentFormTemplateAutocomplete from './TemplateAutocomplete';
// eslint-disable-next-line max-len
import AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedData from './TemplateSelectedData';
import AssistantGenerateRoutesDialogByTemplateContentFormNotTemplatesInfo from './NotTemplatesInfo';

const AssistantGenerateRoutesDialogByTemplateContentForm = (): ReactElement => {
  const {
    data: {
      templates,
      selectedTemplate: { value: selectedTemplate },
    },
  } = useAssistantGenerateRoutesDialogByTemplateContext();

  if (templates.length === 0) {
    return (
      <AssistantGenerateRoutesDialogByTemplateContentFormNotTemplatesInfo />
    );
  }

  return (
    <Stack spacing={2} paddingBottom={2}>
      <AssistantGenerateRoutesDialogByTemplateContentFormTemplateAutocomplete />

      {selectedTemplate && (
        <AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedData />
      )}
    </Stack>
  );
};

export default AssistantGenerateRoutesDialogByTemplateContentForm;
